/**************************************************
 * Nombre:       Seccion_Resultados
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {usuarioContext} from "../../App";
import Tarjeta_Resultados_Funnel from "../Tarjetas/Tarjeta_Resultados_Funnel";
import {contarPropiedadSumaWheres} from "../../Servicios/BD/Contadores/contarPropiedadSumaWheres";
import {where} from "firebase/firestore";
import {contarWheres} from "../../Servicios/BD/Contadores/contarWheres";
import {IDCORREOGLOBAL} from "../../Constantes";


const Seccion_Resultados = () => {
    const cData = useContext(usuarioContext)
    const {sCell} = useResponsive()
    const parms = useParams()
    const [datosGlobales, setDatosGlobales] = useState({})
    const [metricasGlobales, setMetricasGlobales] = useState([])
    const [datosUsuario, setDatosUsuario] = useState({})
    const [metricasUsuario, setMetricasUsuario] = useState([])
    const [campana, setCampana] = useState({})

    const obtenerDatosGlobales = async (idFunnel) => {

        //campanas valor
        let wCapa = [where('idFunnel', '==', idFunnel)]
        let valorTotalCamapanas = await contarPropiedadSumaWheres({
            coleccion: 'campanas',
            wheres: wCapa,
            propiedad: 'valor'
        })

        //Calificados
        let wCalificados = [where('idFunnel', '==', idFunnel), where('celular', '!=', null)]
        let numCalificados = await contarWheres({coleccion: 'leads', wheres: wCalificados})

        //leads funnel
        let wLeadFunell = [where('idFunnel', '==', idFunnel)]
        let leadsCaptados = await contarWheres({coleccion: 'leads', wheres: wLeadFunell})


        let obj = {
            valorTotal: valorTotalCamapanas,
            calificados: numCalificados.data,
            captados: leadsCaptados.data,
            alimentandose: leadsCaptados.data - numCalificados.data,
            celular: numCalificados.data,
        }

        setDatosGlobales(obj)

        //Metricas Embudo

        let arr = []

        let idMetricas = idFunnel + IDCORREOGLOBAL
        let doxEmbudo = await obtenerDoc('metricas', idMetricas)
        if (doxEmbudo.res) {
            let data = doxEmbudo.data
            arr = [
                data.vistaPagina ? data.vistaPagina : 0,
                data.video1 ? data.video1 : 0,
                data.video2 ? data.video2 : 0,
                data.video3 ? data.video3 : 0,
                leadsCaptados.data ? leadsCaptados.data : 0,
            ]
        }

        setMetricasGlobales(arr)


    }


    const obtenerDatosUsuario = async (idFunnel, idUsuario) => {

        //campanas valor
        let wCapa = [where('idFunnel', '==', idFunnel), where('idUsuario', '==', idUsuario)]
        let valorTotalCamapanas = await contarPropiedadSumaWheres({
            coleccion: 'campanas',
            wheres: wCapa,
            propiedad: 'valor'
        })

        //Calificados
        let wCalificados = [where('idFunnel', '==', idFunnel), where('celular', '!=', null), where('idUsuario', '==', idUsuario)]
        let numCalificados = await contarWheres({coleccion: 'leads', wheres: wCalificados})


        //leads funnel
        let wLeadFunell = [where('idFunnel', '==', idFunnel), where('idUsuario', '==', idUsuario)]
        let leadsCaptados = await contarWheres({coleccion: 'leads', wheres: wLeadFunell})


        let obj = {
            valorTotal: valorTotalCamapanas,
            calificados: numCalificados.data,
            captados: leadsCaptados.data,
            alimentandose: leadsCaptados.data - numCalificados.data,
            celular: numCalificados.data,
        }

        setDatosUsuario(obj)

        //Metricas Embudo

        let arr = [0, 0, 0, 0, 0]

        let idMetricas = idFunnel + idUsuario
        let doxEmbudo = await obtenerDoc('metricas', idMetricas)
        if (doxEmbudo.res && doxEmbudo.data) {
            let data = doxEmbudo.data
            arr = [
                data.vistaPagina ? data.vistaPagina : 0,
                data.video1 ? data.video1 : 0,
                data.video2 ? data.video2 : 0,
                data.video3 ? data.video3 : 0,
                leadsCaptados.data ? leadsCaptados.data : 0,
            ]
        }

        setMetricasUsuario(arr)


    }

    const obtenerValoresCampana = async (idCampana) => {

        let doxCapana = await obtenerDoc('campanas', idCampana)
        // console.log(doxCapana)
        if (doxCapana.res && doxCapana.data) {
            setCampana(doxCapana.data)
        }

    }

    useEffect(() => {

        if (parms && parms.id) {
            let id = parms.id
            let idFunnel = parms.idFunnel
            let idUsuario = cData.usuario.id

            obtenerValoresCampana(id, idUsuario).then()

            obtenerDatosUsuario(idFunnel, idUsuario).then()

            obtenerDatosGlobales(idFunnel).then()
        }


    }, [parms, cData]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', pb: 6}}
                spacing={4}
            >

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Resultados_Funnel
                        item={campana}
                        global={true}
                        datos={datosGlobales}
                        series={metricasGlobales}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Resultados_Funnel
                        item={campana}
                        global={false}
                        datos={datosUsuario}
                        series={metricasUsuario}
                    />
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Seccion_Resultados

